import React, { useState } from "react";
import TmsLoginStepOne from "../../components/tms-login/tms-login-step-one";
import TmsLoginStepTwo from "../../components/tms-login/tms-login-step-two";
import "../../assets/css/tms-login/tms-login.scss";
import TmsLoginStepThree from "../../components/tms-login/tms-login-step-three";
import { Row, Col, Card } from "antd";
import {
  aathreya,
  logoFrame,
  tms_slider_1,
  vritix_logo,
} from "../../assets/images/tms-image-list";

const TmsLogin = () => {
  const [page, setPage] = useState(1);
  const [userName, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");

  const getLoginPage = () => {
    switch (page) {
      case 1:
        return (
          <TmsLoginStepOne
            userName={userName}
            setUsername={setUsername}
            setPassword={setPassword}
            password={password}
            setPage={setPage}
          />
        );
      case 2:
        return (
          <TmsLoginStepTwo
            setPage={setPage}
            setPhone={setPhone}
            phone={phone}
          />
        );
      case 3:
        return (
          <TmsLoginStepThree
            setPage={setPage}
            phone={phone}
            setPhone={setPhone}
          />
        );
      default:
        break;
    }
  };

  return (
    <div
      className="vf-login-outer-wrapper"
      style={{
        padding: "2.5rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <div style={{ display: "flex", gap: "10px" }}>
        {/* <img src={aathreya} />
        <img src={logoFrame} /> */}
        <img style={{ width: "200px" }} src={vritix_logo} />
      </div>
      <Card
        className="overflow-hidden rounded-2xl shadow-md"
        bodyStyle={{ padding: 10 }}
        bordered={false}
        style={{
          borderRadius: "20px",
          overflow: "hidden",
        }}
      >
        <Row>
          <Col
            xs={24}
            sm={24}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "30px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <h1 style={{ color: "var(--primary-color)", marginBottom: "0" }}>
                Login
              </h1>

              {getLoginPage()}
            </div>
          </Col>
        </Row>
      </Card>
    </div>
  );
};
export default TmsLogin;
